import { useQuery } from "urql";

import {
  KycResultFilter,
  KycResultOrderBy,
  KycResultsDocument,
} from "../../../graphql/generated";

interface UseKYCResultsProps {
  page?: number;
  limit?: number;
  filter?: KycResultFilter;
  orderBy?: KycResultOrderBy;
}

export const useKYCResults = ({
  page = 1,
  limit = 20,
  filter,
  orderBy,
}: UseKYCResultsProps = {}) => {
  const skip = (page - 1) * limit;

  return useQuery({
    query: KycResultsDocument,
    variables: {
      filter,
      orderBy,
      skip,
      take: limit,
    },
  });
};
